/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import { SeminarCalendarScheduleFragmentDoc } from './SeminarCalendar.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type SeminarScheduleInput = {
  applicationDue: TimeString;
  capacity?: number | null | undefined;
  endedAt: TimeString;
  isOnline: boolean;
  location: string;
  startedAt: TimeString;
};

export type SeminarListPageQueryVariables = Exact<{ [key: string]: never; }>;


export type SeminarListPageQuery = { seminars: Array<{ id: string, title: string, schedules: Array<{ id: string, startedAt: TimeString, endedAt: TimeString, applicantCount: number, isReachedCapacity: boolean, location: string, isOnline: boolean, capacity: number | null, applicationDue: TimeString }> }> };

export type CreateSeminarSchedulesMutationVariables = Exact<{
  seminarId: string | number;
  input: Array<Types.SeminarScheduleInput> | Types.SeminarScheduleInput;
}>;


export type CreateSeminarSchedulesMutation = { createSeminarSchedules: { id: string, title: string, schedules: Array<{ id: string, startedAt: TimeString, endedAt: TimeString, applicantCount: number, isReachedCapacity: boolean, location: string, isOnline: boolean, capacity: number | null, applicationDue: TimeString }> } };

export type UpdateSeminarScheduleMutationVariables = Exact<{
  seminarId: string | number;
  scheduleId: string | number;
  input: Types.SeminarScheduleInput;
}>;


export type UpdateSeminarScheduleMutation = { updateSeminarSchedule: { id: string, startedAt: TimeString, endedAt: TimeString, applicantCount: number, isReachedCapacity: boolean, location: string, isOnline: boolean, capacity: number | null, applicationDue: TimeString } };

export type DeleteSeminarScheduleMutationVariables = Exact<{
  seminarId: string | number;
  scheduleId: string | number;
}>;


export type DeleteSeminarScheduleMutation = { deleteSeminarSchedule: { id: string, title: string, schedules: Array<{ id: string, startedAt: TimeString, endedAt: TimeString, applicantCount: number, isReachedCapacity: boolean, location: string, isOnline: boolean, capacity: number | null, applicationDue: TimeString }> } };

export type DeleteSeminarMutationVariables = Exact<{
  seminarId: string | number;
}>;


export type DeleteSeminarMutation = { deleteSeminar: boolean };


export const SeminarListPageDocument = gql`
    query SeminarListPage {
  seminars {
    id
    title
    schedules {
      ...SeminarCalendarSchedule
    }
  }
}
    ${SeminarCalendarScheduleFragmentDoc}`;

/**
 * __useSeminarListPageQuery__
 *
 * To run a query within a Vue component, call `useSeminarListPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeminarListPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSeminarListPageQuery();
 */
export function useSeminarListPageQuery(options: VueApolloComposable.UseQueryOptions<SeminarListPageQuery, SeminarListPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SeminarListPageQuery, SeminarListPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SeminarListPageQuery, SeminarListPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SeminarListPageQuery, SeminarListPageQueryVariables>(SeminarListPageDocument, {}, options);
}
export function useSeminarListPageLazyQuery(options: VueApolloComposable.UseQueryOptions<SeminarListPageQuery, SeminarListPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SeminarListPageQuery, SeminarListPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SeminarListPageQuery, SeminarListPageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SeminarListPageQuery, SeminarListPageQueryVariables>(SeminarListPageDocument, {}, options);
}
export type SeminarListPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SeminarListPageQuery, SeminarListPageQueryVariables>;
export const CreateSeminarSchedulesDocument = gql`
    mutation createSeminarSchedules($seminarId: ID!, $input: [SeminarScheduleInput!]!) {
  createSeminarSchedules(seminarId: $seminarId, input: $input) {
    id
    title
    schedules {
      ...SeminarCalendarSchedule
    }
  }
}
    ${SeminarCalendarScheduleFragmentDoc}`;

/**
 * __useCreateSeminarSchedulesMutation__
 *
 * To run a mutation, you first call `useCreateSeminarSchedulesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateSeminarSchedulesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateSeminarSchedulesMutation({
 *   variables: {
 *     seminarId: // value for 'seminarId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateSeminarSchedulesMutation(options: VueApolloComposable.UseMutationOptions<CreateSeminarSchedulesMutation, CreateSeminarSchedulesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateSeminarSchedulesMutation, CreateSeminarSchedulesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateSeminarSchedulesMutation, CreateSeminarSchedulesMutationVariables>(CreateSeminarSchedulesDocument, options);
}
export type CreateSeminarSchedulesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateSeminarSchedulesMutation, CreateSeminarSchedulesMutationVariables>;
export const UpdateSeminarScheduleDocument = gql`
    mutation updateSeminarSchedule($seminarId: ID!, $scheduleId: ID!, $input: SeminarScheduleInput!) {
  updateSeminarSchedule(
    seminarId: $seminarId
    scheduleId: $scheduleId
    input: $input
  ) {
    ...SeminarCalendarSchedule
  }
}
    ${SeminarCalendarScheduleFragmentDoc}`;

/**
 * __useUpdateSeminarScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateSeminarScheduleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSeminarScheduleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateSeminarScheduleMutation({
 *   variables: {
 *     seminarId: // value for 'seminarId'
 *     scheduleId: // value for 'scheduleId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSeminarScheduleMutation(options: VueApolloComposable.UseMutationOptions<UpdateSeminarScheduleMutation, UpdateSeminarScheduleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateSeminarScheduleMutation, UpdateSeminarScheduleMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateSeminarScheduleMutation, UpdateSeminarScheduleMutationVariables>(UpdateSeminarScheduleDocument, options);
}
export type UpdateSeminarScheduleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateSeminarScheduleMutation, UpdateSeminarScheduleMutationVariables>;
export const DeleteSeminarScheduleDocument = gql`
    mutation deleteSeminarSchedule($seminarId: ID!, $scheduleId: ID!) {
  deleteSeminarSchedule(seminarId: $seminarId, scheduleId: $scheduleId) {
    id
    title
    schedules {
      ...SeminarCalendarSchedule
    }
  }
}
    ${SeminarCalendarScheduleFragmentDoc}`;

/**
 * __useDeleteSeminarScheduleMutation__
 *
 * To run a mutation, you first call `useDeleteSeminarScheduleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSeminarScheduleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteSeminarScheduleMutation({
 *   variables: {
 *     seminarId: // value for 'seminarId'
 *     scheduleId: // value for 'scheduleId'
 *   },
 * });
 */
export function useDeleteSeminarScheduleMutation(options: VueApolloComposable.UseMutationOptions<DeleteSeminarScheduleMutation, DeleteSeminarScheduleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteSeminarScheduleMutation, DeleteSeminarScheduleMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteSeminarScheduleMutation, DeleteSeminarScheduleMutationVariables>(DeleteSeminarScheduleDocument, options);
}
export type DeleteSeminarScheduleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteSeminarScheduleMutation, DeleteSeminarScheduleMutationVariables>;
export const DeleteSeminarDocument = gql`
    mutation deleteSeminar($seminarId: ID!) {
  deleteSeminar(seminarId: $seminarId)
}
    `;

/**
 * __useDeleteSeminarMutation__
 *
 * To run a mutation, you first call `useDeleteSeminarMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSeminarMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteSeminarMutation({
 *   variables: {
 *     seminarId: // value for 'seminarId'
 *   },
 * });
 */
export function useDeleteSeminarMutation(options: VueApolloComposable.UseMutationOptions<DeleteSeminarMutation, DeleteSeminarMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteSeminarMutation, DeleteSeminarMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteSeminarMutation, DeleteSeminarMutationVariables>(DeleteSeminarDocument, options);
}
export type DeleteSeminarMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteSeminarMutation, DeleteSeminarMutationVariables>;